export default {
  getDefaultState: () => {
    return {
      isCallingResources: false,
      resources: [],
      resourceIdList: [],
      resource: null
    }
  }
}
